import React from 'react';
import { EMBLEM_BARS, EMBLEM_SQUARE_VIEW_BOX } from '../../../music24/components/music24BrandPaths';

interface LogoProps {
  size?: number;
}

/** The Music24 emblem in a square box (the consent tile). Use `Music24FullLogo` for the brand in a top bar. */
export const AuthLogo: React.FC<LogoProps> = ({ size = 26 }) => (
  <svg
    width={size}
    height={size}
    viewBox={EMBLEM_SQUARE_VIEW_BOX}
    fill="none"
    aria-hidden="true"
    className="au-logo"
    data-testid="music24-emblem"
  >
    {EMBLEM_BARS.map((bar) => (
      <path key={bar.fill} fill={bar.fill} d={bar.d} />
    ))}
  </svg>
);
